<template>
	<module class="g-head" flex="flex-between-center">
		<img class="logo" src="@/assets/image/login/logo.png"></img>
		<div>
			<div v-if="userInfo.id" class="user flex-end-center">
				<i class="tf">&#xe670;</i>
				<span>{{userInfo.name}}</span>
				<a style="color: #E63633;" @click="logout">【退出】</a>
			</div>
			<div v-else class="user flex-end-center">
				<span>欢迎使用数字保函系统！</span>
				<a style="color: #1492FF;" @click="navigateTo('/login')">【立即登录】</a>
			</div>
			<div class="nav flex">
				<div class="item"><router-link to="/">首页</router-link></div>
				<div class="item">
					<span>业务办理<i class="tf tf-angle-down"></i></span>
					<ul>
						<div v-for="(item, i) in menuList" :key="i">
							<router-link :to="item.path"><li>{{item.name}}</li></router-link>
						</div>
					</ul>
				</div>
				<div v-if="RE == 'Alpha'" class="item">
					<span>切换角色</span>
					<ul>
						<div v-for="(item, i) in roleList" :key="i">
							<a @click="changeRole(item.data)"><li>{{item.name}}</li></a>
						</div>
					</ul>
				</div>
				<div class="item"><router-link to="/manual">操作手册</router-link></div>
			</div>
		</div>
	</module>
</template>

<script>
	import routes from '@/router/routes.js'
	import {mapState, mapGetters} from 'vuex'
	import fun from '@/assets/script/function.js'
	
	export default {
		data() {
			return {
				RE: this.getRE(),
				roleList: [{
					name: '招标代理',
					data: {
						user_id: 'dl0000000001'
					}
				}, {
					name: '企业角色',
					data: {
						user_id: 'qy0000000001'
					}
				}, {
					name: '监理角色',
					data: {
						user_id: 'jl0000000001'
					}
				}, {
					name: '保险公司',
					data: {
						user_id: 'bx0000000001'
					}
				}, {
					name: '协助理赔',
					data: {
						user_id: 'lp0000000001'
					}
				}]
			}
		},
		
		computed: {
			...mapState(['elder', 'userInfo']),
			...mapGetters(['menuList'])
		},
		
		mounted() {
			let title = '数字保函';
			for (let i = this.$route.matched.length - 1; i >= 0; i--) {
				if (this.$route.matched[i].meta.name) {
					title += `- ${this.$route.matched[i].meta.name}`;
					break;
				}
			}
			document.getElementsByTagName('title')[0].innerHTML = title
		},
		
		methods: {
			changeRole(data) {
				this.request({
					url: '/user/login',
					data,
					loading: true,
					success: data => {
						fun.setCookie('session_id', data.sessionId);
						location.href = '/';
					}
				});
			},
			
			logout() {
				this.$confirm({
					text: '确定要退出登录吗？',
					resolve: () => {
						fun.removeCookie('session_id');
						this.$store.commit('setUserInfo', {});
						this.navigateTo('/login');
					}
				});
			}
		}
	};
</script>

<style lang="stylus" scoped>
	.g-head {
		z-index: 9;
		position: relative;
		background: #fff;
		
		.logo {
			height: 36px;
		}
		
		.user {
			margin: 26px 0 20px;
			font-size: 14px;
			
			.tf {
				margin-right: 8px;
			}
			
			a:hover {
				opacity: .8;
			}
		}

		.nav {
			.item {
				position: relative;
				margin-left: 50px;
				color: #000;
				
				&:hover {
					color: #117CD9;
					
					&:after {
						content: '';
						position: absolute;
						left: 0;
						bottom: 0;
						width: 100%;
						height: 3px;
						background: #1492FF;
					}
					
					ul {
						display: block;
					}
				}
				
				> a, > span {
					display: block;
					line-height: 70px;
					font-size: 20px;
					font-weight: bold;
					
					.tf {
						vertical-align: top;
						margin-left: 8px;
						font-size: 16px;
						
						elder({
							font-size: 26px
						})
					}
					
					elder({
						font-size: 30px
					})
				}
				
				ul {
					display: none;
					position: absolute;
					left: 0;
					top: 100%;
					width: 200px;
					padding: 10px 0;
					background: #fff;
					box-shadow: 0 5px 5px 0 rgba(0,0,0,.2);
					
					li {
						padding: 0 15px;
						line-height: 36px;
						font-size: 15px;
						color: #000;
					
						elder({
							line-height: 50px,
							font-size: 24px
						})
						
						&:hover {
							color: #1492FF;
							background: #E7F4FF;
						}
						
						ins {
							margin-left: 6px;
							color: #E63633;
						}
					}
				}
			}
		}
	}
</style>
